import questionManger from "@/pages/questionManager/index"
export default [
    {
        path: 'question-manager', // 邮件发送
        name: "questionManger",
        component: questionManger
    },
]
